<div class="card mb-5">
    <div class="card-header">
		<h3>Histórico de Procesos Productivos
		</h3>
	</div>

    <div class="card-body">
        <div class="row">
            <div class="col relative" id="list-container">
                <h5>Filtrar</h5>
				<div class="row" id="options-date">
					<div class="col-sm form-group">
						<label for="type" class="form-label">Ver resultados de </label>
						<select name="type" id="type" (change)="changeType()" [(ngModel)]="type" class="form-select">
							<option value="0">Hoy</option>
							<option value="1">Últimos 7 días</option>
							<option value="2">Este mes</option>
							<option value="3">El mes pasado</option>
							<option value="4">Últimos dos meses</option>
							<option value="5">Últimos tres meses</option>
							<option value="6">Intervalo de fecha</option>
						</select>
					</div>
					<div class="col-sm form-group" *ngIf="type==6">
						<label for="startDate" class="form-label">Fecha Inicio</label>
						<input type="date" id="startDate" (change)="changeDate()" [(ngModel)]="startDate"
							name="startDate" class="form-control">
					</div>
					<div class="col-sm form-group" *ngIf="type==6">
						<label for="endDate" class="form-label">Ver resultados de </label>
						<input type="date" id="endDate" max="{{todayDate | date:'yyyy-MM-dd'}}" (change)="changeDate()"
							[(ngModel)]="endDate" name="endDate" class="form-control">
					</div>
				</div>
                <div class="row mt-3" id="options-other-filters">
                    <div class="col-sm form-group">
                        <label for="filterReservations" class="form-label">Buscar</label>
                        <div class="input-group">
                        <input
                            type="text"
                            id="filterReservations"
                            [(ngModel)]="filterWord"
                            placeholder="Ingresa nombre del proceso..."
                            class="form-control"
                        />
                        <button class="btn btn-primary" (click)="searching()">
                            <i class="fa fa-search"></i>
                        </button>
                        </div>
                    </div>
                </div>

                <div class="table-responsive">
					<table class="table table-striped">
						<thead>
							<tr class="thead-index">
								<th class="text-left">
									Proceso
								</th>
								<th class="text-left">
									Usuario que Ejecutó
								</th>
								<th class="ta">
									Fecha Ejecución
								</th>
                                <th class="text-right">
									Costo Estandar
								</th>
                                <th class="text-right">
									Costo Real
								</th>
								<th class="ta">
									Acciones
								</th>
							</tr>
						</thead>
						<tbody>
							<ng-container *ngFor="let item of pagination.filter">
								<tr>
									<td class="text-left">
										{{item.productionProcess.name}}
									</td>
									<td class="text-left">
										{{item.createdByFirstName + " " + item.createdByLastName}}
									</td>
									<td class="ta">
										{{convertToString(item.production.creationDate)}}
									</td>
									<td class="text-right">
										Q {{item.production.standardCost | number:'1.2-2'}}
									</td>
									<td class="text-right">
										Q {{item.production.realCost | number:'1.2-2'}}
									</td>
									<td class="ta">
                                        <span (click)="showDetail(item)" title="Ver"
                                            class="clickeable text-info">
                                            <i *ngIf="!detailing[item.production.id]" class="fa fa-eye"></i>
                                            <i *ngIf="detailing[item.production.id]" class="fa fa-eye-slash"></i>
                                            <!-- <span *ngIf="detailing[item.production.id]"
                                                class="spinner-border spinner-border-sm" aria-hidden="true"></span> -->
                                        </span>
                                        <!-- <span (click)="downloadInvoice(invoice)" title="Descargar"
                                            *ngIf="invoice.gfaceGenerated || invoice.downloadable"
                                            class="clickeable text-info" [appCheckPermission]="[2046]"
                                            [permissionType]="permissionType.READ">
                                            <i *ngIf="!loadingDownload[invoice.id]"
                                                class="fa-solid fa-download"></i>
                                            <span *ngIf="loadingDownload[invoice.id]"
                                                class="spinner-border spinner-border-sm" aria-hidden="true"></span>
                                        </span> -->
									</td>
								</tr>
                                <tr *ngIf="detailing[item.production.id]">
                                    <td></td>
                                    <td colspan="6">
                                        <app-production-details [details]="item.production.details" [productionId]="item.production.id"/>
                                        <app-production-details-result [detailsResult]="item.production.detailsResult" [productionId]="item.production.id"/>
                                    </td>
                                </tr>
							</ng-container>
							<tr *ngIf="pagination.filter.length == 0 && !loading">
								<td colspan="9" class="ta" style="color: gray">
									<i class="fa fa-circle-info"></i>
									{{reportList.length == 0?'No se encontraron procesos productivos en las fechas seleccionadas':
									'No se encontraron resultados para el filtro aplicado'}}
								</td>
							</tr>
						</tbody>
                        
					</table>
				</div>
			    <div class="col-sm" *ngIf="loading">
                    <span class="row display-5 text-center items-center justify-center">
                        <app-loading-animation [height]="'8rem'"></app-loading-animation>
                        Cargando...
                    </span>
                </div>
                <app-pagination-custom [elements]="pagination"></app-pagination-custom>
            </div>
        </div>
    </div>
</div>
